import { render, staticRenderFns } from "./MotoristaApp.vue?vue&type=template&id=dd876dd0&scoped=true&"
import script from "./MotoristaApp.vue?vue&type=script&lang=js&"
export * from "./MotoristaApp.vue?vue&type=script&lang=js&"
import style0 from "./MotoristaApp.vue?vue&type=style&index=0&id=dd876dd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd876dd0",
  null
  
)

export default component.exports